import { render, staticRenderFns } from "./OnClick.vue?vue&type=template&id=7f386c43&scoped=true"
import script from "./OnClick.vue?vue&type=script&lang=js"
export * from "./OnClick.vue?vue&type=script&lang=js"
import style0 from "./OnClick.vue?vue&type=style&index=0&id=7f386c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f386c43",
  null
  
)

export default component.exports